export const formatInstagramDisplay = (instagram) => {
  if (!instagram) return '';

  const value = instagram.trim();
  if (!value) return '';

  if (value.startsWith('http')) {
    try {
      const username = new URL(value).pathname.replace(/^\//, '').split('/')[0];
      return username ? `@${username}` : value;
    } catch {
      return value;
    }
  }

  return value.startsWith('@') ? value : `@${value}`;
};

export const getInstagramUrl = (instagram) => {
  if (!instagram) return '';

  const value = instagram.trim();
  if (!value) return '';

  if (value.startsWith('http')) {
    return value;
  }

  const username = value.replace(/^@/, '');
  return `https://instagram.com/${username}`;
};

export const isValidInstagram = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return false;

  if (/^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?$/i.test(trimmed)) {
    return true;
  }

  return /^@?[a-zA-Z0-9._]{1,30}$/.test(trimmed);
};
